import { connect } from 'react-redux';
import { fetchColors } from '../actions/colors';
import { getOtp } from '../selectors';
import Slide from '../components/Slide.jsx';

const mapStateToProps = (state, props) => {
  const slide = state.slides.byId[props.id];

  return {
    ...(slide || {}),
    otp: getOtp(state),
    uiMode: state.ui.mode,
    focusMode: state.ui.componentFocusId !== null
  };
};

const mapDispatchToProps = {
  fetchColors,
};

export default connect(mapStateToProps, mapDispatchToProps)(Slide);
